import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardComponent } from './dashboard.component';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgApexchartsModule } from 'ng-apexcharts';
import { FullCalendarModule } from '@fullcalendar/angular';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { NgxEditorModule } from 'ngx-editor';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ColorPickerModule } from 'ngx-color-picker/public-api';
import { NgxDropzoneModule } from 'ngx-dropzone/lib/ngx-dropzone.module';
import { NgxMatTimepickerModule } from 'ngx-mat-timepicker/public-api';
import { NgxGaugeModule } from 'ngx-gauge';
import { CdkAccordionModule } from '@angular/cdk/accordion';
import { HttpClientModule } from '@angular/common/http';
import { NgChartsModule } from 'ng2-charts';
import { SharedModule } from 'src/app/core/shared-modules/shared.module';
import { DashboardRoutingModule } from './dashboard-routing.module';

@NgModule({
    declarations: [DashboardComponent],
    imports: [CommonModule,
        DashboardRoutingModule,
        TranslateModule,
        FormsModule,
        ReactiveFormsModule,
        NgApexchartsModule,
        FullCalendarModule,
        NgScrollbarModule,
        CarouselModule,
        NgxEditorModule,
        HttpClientModule,
        // ColorPickerModule,
        SharedModule,
    ],
})
export class DashboardModule {}
